import { StyleSheet, View } from "react-native";
import React from "react";
import color from "@constants/color";
import Text from "@components/CustomText";

const ErrorText = ({ text }) => {
  return (
    <View style={styles.container}>
      <Text variant="caption_1" style={styles.text}>
        {text}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "rgba(255, 77, 79, 0.05)",
    borderRadius: 4,
    width: "100%",
  },
  text: {
    padding: 4,
    color: color.plain_red,
    textAlign: "center",
  },
});

export default ErrorText;
